import api from "@/core/services/axios";
import type { ReleaseNotes, Version } from "@/models";

export class InfoService {
  constructor(private readonly baseRoute = "/info") {}

  async fetchVersion(): Promise<Version> {
    const res = await api.get<Version>(`${this.baseRoute}/version`);
    return res.data;
  }

  async fetchReleaseNotes(): Promise<ReleaseNotes[]> {
    const res = await api.get<ReleaseNotes[]>(`${this.baseRoute}/release-notes`);
    return res.data;
  }
}

export const infoService = new InfoService();
